import { EmptystateVcsColored } from "components/icons/generated";
import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";

const VCSAgentPoolAgentsEmpty = () => {
  return (
    <EmptyState
      icon={EmptystateVcsColored}
      title="No belonging agents yet"
      caption={
        <>
          No agents belonging to this VCS Agent Pool are currently connected to our gateway. Feel
          free to refer to the docs on{" "}
          <ReadMoreDocsLink
            docsUrl={getDocsUrl(
              /* @ignore-checking-sh-docs */
              "/concepts/vcs-agent-pools"
            )}
            title="how to set up VCS agents"
          />
          .
        </>
      }
    />
  );
};

export default VCSAgentPoolAgentsEmpty;
